/* Decor Walay — cart-drawer.js */
(function () {
  'use strict';

  function qs(sel, ctx)  { return (ctx||document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }
  function openDrawer(el)  { if(!el)return; el.classList.add('is-open'); el.setAttribute('aria-hidden','false'); document.body.classList.add('drawer-open'); }
  function closeDrawer(el) { if(!el)return; el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); if(!qsa('.drawer.is-open').length) document.body.classList.remove('drawer-open'); }
  function closeAllDrawers() { qsa('.drawer.is-open').forEach(closeDrawer); }

  function money(cents) {
    return window.formatMoney ? window.formatMoney(cents) : 'Rs.' + (cents / 100).toFixed(2);
  }

  function getThreshold() {
    return window.DW_FREE_SHIPPING_THRESHOLD || 0;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var searchDrawer = qs('[data-search-drawer]');
    var cartDrawer   = qs('[data-cart-drawer]');
    var searchToggle = qs('[data-search-toggle]');
    var cartToggle   = qs('[data-cart-toggle]');

    if (searchToggle) searchToggle.addEventListener('click', function(){
      closeAllDrawers(); openDrawer(searchDrawer);
      var i = qs('input[type="text"]', searchDrawer); if(i) i.focus();
    });

    if (cartToggle) cartToggle.addEventListener('click', function(){
      closeAllDrawers();
      openDrawer(cartDrawer);
    });

    qsa('[data-drawer-close]').forEach(function(btn){ btn.addEventListener('click', closeAllDrawers); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeAllDrawers(); });

    qsa('.site-nav__item.has-dropdown > .site-nav__link').forEach(function(link){
      link.addEventListener('click', function(e){
        if(window.matchMedia('(max-width:989px)').matches){ e.preventDefault(); link.closest('.site-nav__item').classList.toggle('is-open'); }
      });
    });

    initCart();
  });

  function initCart() {
    document.addEventListener('submit', function(e){
      var form = e.target.closest('[data-add-to-cart-form]');
      if (!form) return;
      e.preventDefault();
      fetch('/cart/add.js', { method:'POST', body:new FormData(form), headers:{Accept:'application/json'} })
        .then(function(r){ return r.json(); })
        .then(function(res){
          if(res.status){ console.error(res.description); return; }
          renderCartFromServer();
          closeAllDrawers();
          openDrawer(qs('[data-cart-drawer]'));
        })
        .catch(console.error);
    });

    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json', Accept:'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function(r){ return r.json(); })
        .then(function(res){
          if(res.status){ console.error(res.description); return; }
          renderCartFromServer();
          closeAllDrawers();
          openDrawer(qs('[data-cart-drawer]'));
        })
        .catch(console.error);
    });

    document.addEventListener('click', function(e){
      var incr = e.target.closest('[data-cart-qty-increase]');
      var decr = e.target.closest('[data-cart-qty-decrease]');
      var rem  = e.target.closest('[data-cart-remove]');
      if(!incr && !decr && !rem) return;
      var itemEl = e.target.closest('[data-cart-item]'); if(!itemEl) return;
      var key    = itemEl.getAttribute('data-cart-item');
      var qtyEl  = qs('[data-cart-qty-value]', itemEl);
      var qty    = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      changeCartItem(key, incr ? qty+1 : (decr ? Math.max(0, qty-1) : 0));
    });
  }

  function changeCartItem(key, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ id:key, quantity:qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(){ renderCartFromServer(); })
    .catch(console.error);
  }

  function renderCartFromServer(){
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        renderCartDrawer(cart);
        qsa('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
        qsa('[data-cart-drawer-count]').forEach(function(el){ el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(console.error);
  }

  function renderCartDrawer(cart){
    var body = qs('[data-cart-drawer-body]'); if(!body) return;
    if(cart.item_count === 0){
      body.innerHTML = '<p class="cart-drawer__empty-msg">Your cart is currently empty.</p>';
      return;
    }

    var itemsHtml = cart.items.map(function(item){
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer__item-variant">' + item.variant_title.toUpperCase() + '</p>' : '';
      return '<li class="cart-drawer__item" data-cart-item="' + item.key + '">' +
        '<div class="cart-drawer__item-media">' + (item.image ? '<img src="' + item.image + '" alt="' + esc(item.title) + '" loading="lazy">' : '') + '</div>' +
        '<div class="cart-drawer__item-info">' +
          '<p class="cart-drawer__item-title">' + esc(item.product_title) + '</p>' + variant +
          '<p class="cart-drawer__item-price">' + money(item.final_price) + '</p>' +
          '<div class="cart-drawer__qty">' +
            '<button type="button" data-cart-qty-decrease>&minus;</button>' +
            '<span data-cart-qty-value>' + item.quantity + '</span>' +
            '<button type="button" data-cart-qty-increase>+</button>' +
            '<button type="button" data-cart-remove><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6M9 6V4h6v2"/></svg></button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('');

    var threshold = getThreshold();
    var shippingHtml = '';
    if (threshold > 0) {
      if (cart.total_price >= threshold) {
        shippingHtml =
          '<p class="cart-drawer__shipping-msg cart-drawer__shipping-msg--success">You\'ve got free shipping!</p>' +
          '<div class="progress-bar"><div class="progress-bar__fill" style="width:100%"></div></div>';
      } else {
        var pct = Math.min((cart.total_price / threshold) * 100, 100);
        shippingHtml =
          '<p class="cart-drawer__shipping-msg">Add ' + money(threshold - cart.total_price) + ' more for free shipping</p>' +
          '<div class="progress-bar"><div class="progress-bar__fill" style="width:' + pct + '%"></div></div>';
      }
    }

    body.innerHTML =
      '<ul class="cart-drawer__items">' + itemsHtml + '</ul>' +
      '<div class="cart-drawer__footer">' +
        '<div class="cart-drawer__total"><span>Total:</span><span data-cart-total>' + money(cart.total_price) + '</span></div>' +
        (threshold > 0
          ? '<div class="cart-drawer__shipping-bar" data-free-shipping-bar data-threshold="' + threshold + '">' + shippingHtml + '</div>'
          : '') +
        '<a href="/cart" class="btn btn--secondary cart-drawer__btn">View Cart</a>' +
        '<a href="/cart/checkout" class="btn btn--primary cart-drawer__btn">Check Out</a>' +
        '<label class="cart-drawer__terms"><input type="checkbox"> I agree with the <a href="/pages/terms-and-conditions">Terms &amp; Conditions</a></label>' +
      '</div>';
  }

  function esc(str){ var d = document.createElement('div'); d.textContent = str || ''; return d.innerHTML; }

  window.DecorWalayCart = {
    refresh: renderCartFromServer,
    open: function(){
      closeAllDrawers();
      openDrawer(qs('[data-cart-drawer]'));
    }
  };

})();
